import { filterProductsByCabinType, findFirstCruiseService } from '../filters';
import { isCabinType } from '../guards';

import type { CabinType, ProductWithServices } from '../types';

/**
 * Returns a list of all available cabin types.
 */
export const getAvailableCabinTypes = (): CabinType[] => [
  'SingleInterior',
  'SingleOutside',
  'SingleBalcony',
  'Interior',
  'Outside',
  'Balcony',
  'Veranda',
  'Family',
  'JuniorSuite',
  'Suite',
];

/**
 * Returns a sort index corresponding to given cabin type.
 */
export const getCabinSortIndex = (type: string): number => {
  const idx = getAvailableCabinTypes().indexOf(type as CabinType);

  if (idx > -1) {
    return idx;
  }

  return 99;
};

/**
 * Returns the given cabin type if available, or the cheapest one.
 */
export const getSpecifiedOrCheapestCabinType = (
  products: ProductWithServices[],
  cabinType: CabinType | undefined,
): CabinType => {
  if (typeof cabinType !== 'undefined') {
    const filtered = filterProductsByCabinType(products, cabinType);

    if (filtered.length > 0) {
      return cabinType;
    }
  }

  if (products.length === 0) {
    return 'Interior';
  }

  const cruiseService = findFirstCruiseService(products[0]);

  const type = cruiseService?.variant?.cabin.cabinType;

  if (isCabinType(type)) {
    return type;
  }

  return 'Interior';
};
